import { Component, inject, OnChanges, WritableSignal, signal, input } from '@angular/core';
import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { firstValueFrom } from 'rxjs';
import { AssignmentService, AssignmentType, CrateDto } from '../../shared/generated/backend';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-assignment-crate',
  imports: [SharedModule, RichTextEditorModule, DxDataGridModule],
  standalone: true,
  templateUrl: './assignment-crate.component.html',
  styleUrl: './assignment-crate.component.scss',
})
export class AssignmentCrateComponent implements OnChanges {
  readonly assignmentId = input.required<number>();

  readonly type = input.required<AssignmentType>();

  crates: WritableSignal<CrateDto[]> = signal([]);
  readonly isLoading: WritableSignal<boolean> = signal(false);

  private assignmentService = inject(AssignmentService);

  async ngOnChanges() {
    this.isLoading.set(true);
    const dto = await firstValueFrom(this.assignmentService.getNumberCrates(this.assignmentId(), this.type()));
    // console.log(this.assignmentId);
    this.crates.set(dto);
    this.isLoading.set(false);
  }
}
